module.exports = __webpack_public_path__ + "media/images/packe_logo-92a5eb44fe7729e72f034bf55506d10d.png";